import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';      // <-- Yahan Import kiya
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="bg-light text-dark font-monospace" style={{ minHeight: '100vh', fontFamily: 'sans-serif' }}>
      <Header />
      <Hero />
      <About />      {/* <-- Hero ke baad About section add kar diya */}
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}